import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultEventsContent } from '../../siteContent';
import { useCms, Text } from './cmsShared';

const AdminContentEvents = () => {
  const { content, update, save, saving } = useCms('events', defaultEventsContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">Events Page — Content</h2>
          <p className="text-sm text-gray-500">Edit the page hero and Corporate Life Series promo card. Actual events are managed in the Events tab.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-events-page-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'cls']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Hero Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Eyebrow label" value={c.hero.eyebrow} onChange={(v) => update(['hero', 'eyebrow'], v)} />
            <Text label="Heading" value={c.hero.heading} onChange={(v) => update(['hero', 'heading'], v)} area />
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="cls" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Corporate Life Series Card (navy)</AccordionTrigger>
          <AccordionContent>
            <Text label="Card heading" value={c.clsCard.heading} onChange={(v) => update(['clsCard', 'heading'], v)} />
            <Text label="Card subtext" value={c.clsCard.subtext} onChange={(v) => update(['clsCard', 'subtext'], v)} area />
            <Text label="Button label" value={c.clsCard.cta} onChange={(v) => update(['clsCard', 'cta'], v)} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AdminContentEvents;
